import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["id", "name", "label", "labelProps", "success", "warning", "error", "tooltip", "tooltipProps", "disabled", "autoTooltip", "disableTooltip", "alignTooltip"];
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import AccessibleField from '../AccessibleField/AccessibleField';
import { extractFieldStyleProps } from '../helpers/omit';
import { TextInput } from '../TextInput/TextInput';
var TextInputFieldBase = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var id = props.id,
      name = props.name,
      label = props.label,
      labelProps = props.labelProps,
      success = props.success,
      warning = props.warning,
      error = props.error,
      tooltip = props.tooltip,
      tooltipProps = props.tooltipProps,
      disabled = props.disabled,
      autoTooltip = props.autoTooltip,
      disableTooltip = props.disableTooltip,
      alignTooltip = props.alignTooltip,
      inputProps = _objectWithoutProperties(props, _excluded);

  var styleProps = extractFieldStyleProps(inputProps);
  return /*#__PURE__*/React.createElement(AccessibleField, Object.assign({
    disabled: disabled,
    id: id,
    name: name,
    label: label,
    labelProps: labelProps,
    success: success,
    warning: warning,
    error: error,
    tooltip: tooltip,
    tooltipProps: tooltipProps,
    autoTooltip: autoTooltip,
    disableTooltip: disableTooltip,
    alignTooltip: alignTooltip
  }, styleProps), function (_ref) {
    var fieldId = _ref.fieldId,
        status = _ref.status,
        ariaDescribedBy = _ref.ariaDescribedBy,
        accessibilityDisabled = _ref.disabled;
    return /*#__PURE__*/React.createElement(TextInput, Object.assign({
      ref: ref
    }, inputProps, {
      disabled: accessibilityDisabled,
      id: fieldId,
      width: "100%",
      status: status,
      name: name,
      "aria-describedby": ariaDescribedBy
    }));
  });
});
export var TextInputField = /*#__PURE__*/styled(TextInputFieldBase).withConfig({
  displayName: "TextInputField"
})(["position:relative;"]);
TextInputField.propTypes = {
  label: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  labelProps: PropTypes.object,
  success: PropTypes.node,
  warning: PropTypes.node,
  error: PropTypes.node,
  tooltip: PropTypes.node,
  tooltipProps: PropTypes.object
};
export default TextInputField;